import type { TimeGapPolicy } from '../../../core/types/gap-policy.js';

export function resolveGapPolicy(
  slotPolicies: (TimeGapPolicy | undefined)[],
  rootPolicy?: TimeGapPolicy,
): TimeGapPolicy | undefined {
  const defined = slotPolicies.filter(
    (p): p is TimeGapPolicy => p !== undefined,
  );

  if (defined.some((p) => p === 'connect')) {
    return 'connect';
  }

  if (defined.length > 0) {
    return defined[0];
  }

  return rootPolicy;
}
